import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import Dashboard from './dashboard/Dashboard';
import Battery from './setup/battery';
import Charger from './setup/charger';
import Employee from './setup/employee';
import Rack from './setup/rack';
import Station from './setup/station';
import Swap from './Swap/Swap';
import Batteries from './liveBatteries/LiveBatteries';
import Customer from './customers/Customers';
import Vehicle from './setup/Vehicle';
import OrganisationConfig from './organisationConfig';

const SetupRoutes: React.FC = () => {
  return (
    <Routes>
      {/* <Route path='/dashboard' element={<Dashboard />} /> */}
      <Route path='/' element={<Navigate to={'/batteries'} />} />
      <Route path='/setup' element={<Navigate to={'employee'} />} />
      <Route path='/setup/employee/*' element={<Employee />} />
      <Route path='/setup/station/*' element={<Station />} />
      <Route path='/setup/rack/*' element={<Rack />} />
      <Route path='/setup/charger/*' element={<Charger />} />
      <Route path='/setup/battery/*' element={<Battery />} />
      <Route path='/setup/vehicle' element={<Vehicle />} />
      <Route path='/transactions' element={<Swap />} />
      <Route path='/customers' element={<Customer />} />
      <Route path='/organisationconfig' element={<OrganisationConfig />} />
      <Route path='/batteries' element={<Batteries />} />
      <Route path='*' element={<Navigate to={'/404/'} />} />
    </Routes>
  );
};

export default SetupRoutes;
